<div class="price-agreements-summary clearfix">
  <h4 class="float-start">{{'financial.price-agreements'|translate}}</h4>
  <div class="summary horizontal float-end mt-1 clearfix">
    <div class="data-column">
      <div class="title me-2">{{'entity.active'|translate}}:</div>
      <div class="value">{{data.active}}</div>
    </div>
    <div class="data-column">
      <div class="title me-2">Verloopt binnenkort:</div>
      <div class="value">{{data.expiringSoon}}</div>
    </div>
    <div class="data-column">
      <div class="title me-2">{{'entity.blocked'|translate}}:</div>
      <div class="value">{{data.blocked}}</div>
    </div>
  </div>
</div>
